import Storage from './Storage';

/**
 * Store CheckoutStatus
 * 
 */
class CheckoutStatus extends Storage {
    storeName = 'checkout_status_';
    hasOldKey = true;

    /**
     * CheckoutStatus constructor
     * 
     * @param {string} id client id
     */
    constructor(id) {
        super();
        this.id = id;
        this.setKey();
    }

    /**
     *  @override
     * 
     * Format data for store
     * 
     * @param {any} data data to store
     * @returns 
     */
    formatSetData(data) {
        return data;
    }

    /**
     *  @override
     * 
     * Format data for store
     * 
     * @param {any} data data to store
     * @returns 
     */
     formatSetDataOld(data) {
        return data;
    }

    /**
     * @override
     * 
     * Format data for get
     * 
     * @param {any} data data to store
     * @returns 
     */
    formatGetData(data) {
        return data;
    }

}

export default CheckoutStatus;